
export const messages = {
  nb: {
    // from onboardingContainer.i18n.js
    header: `Onboarding hos Kreditorforeningen`,
    beskrivelse: `Dersom du ønsker å bli kunde hos kreditorforeningen, kan du selv registrere deg med brukernavn og passord her.`,
    Lagre: `Oppdater profilen`,
    getBronnoysundInfo: "Klikk på knappen for å hente info fra brønnøysund",
    getBronnoysund: "Hent firmainfo",
    orgnrLabel: "Oppgi organisasjonsnr",
    orgnrPlaceholder: "Oppgi 9 sifret organisasjonsnummer",
    orgnrSmall: '"Hent Firmainfo" henter data fra Brønnøysundregistrene. ',
    firmainformasjon: "Informasjon om firma",
    brukerInformasjon: "Informasjon om bruker av KF Portal",
    annenInfo: "Annen informasjon",
    momsPliktigLabel: "Momspliktig",
    momsPliktigPlaceholder: " ",
    prodTypeLabel: "Produkttype",
    prodTypePlaceholder: " ",
    firmanavnLabel: "Firmanavn",
    firmanavnPlaceholder: " ",
    adresseLabel: "Adresse",
    adressePlaceholder: " ",
    postnrLabel: "Postnr",
    postnrPlaceholder: " ",
    poststedLabel: "Poststed",
    poststedPlaceholder: " ",
    firmaepostLabel: "Firmaepost",
    firmaepostPlaceholder: " ",
    kontonrLabel: "Kontonr",
    kontonrPlaceholder: " ",
    brukernavnLabel: "Navn på bruker",
    brukernavnPlaceholder: " ",
    brukeridLabel: "Epostadresse (benyttes for pålogging) ",
    brukeridPlaceholder: " ",
    passordLabel: "Passord (min 8 tegn, store/små/tall og spesialtegn)",
    passordPlaceholder: "",
    gjentapassordLabel: "Gjenta passord",
    gjentapassordPlaceholder: " ",
    telefonnrLabel: "Telefonnr ",
    telefonnrPlaceholder: " ",
    okonomisystemLabel: "Økonomisystem",
    okonomisystemPlaceholder: " ",
    foreningLabel: "Forening",
    foreningPlaceholder: " ",
    kommentarLabel: "Kommentar",
    orgNrIsRequired: "Organisasjonsnummer må oppgis. ",
    isValidOrgNr: "Du har ikke oppgitt et gyldig organisasjonsnummer. ",
    firmanavnIsRequired: "Firmanavn må oppgis. ",
    adresseIsRequired: "Adresse må oppgis. ",
    postnrIsRequired: "Postnummer må oppgis. ",
    postnrInvalid: "Postnummer må være 4 siffer.",
    poststedIsRequired: "Poststed må oppgis. ",
    kontonrIsRequired: "Kontonummer må oppgis. ",
    isValidInteger: "Kun siffer (0-9) tillatt. ",
    isValidKontoNr: "Du har ikke oppgitt en gyldig bankkonto. ",
    fullNameisRequired: "Fullt navn må oppgis. ",
    brukeridIsRequired: "BrukerId må oppgis. ",
    momsPliktigIsRequired: "Momsplikt må oppgis. ",
    prodTypeIsRequired: "Produkttype må oppgis. ",
    foreningRequired: "Forening må oppgis. ",
    financialSystemRequired: "Økonomisystem må oppgis.",
    passWordRequired: "Passord må oppgis. ",
    isValidPhone: "Telefonnummer er ikke gyldig. ",
    checkEqualPasswords: "Passordene er ikke like. ",
    validatePassword: "Passord må ha minst 8 tegn, både store og små bokstaver, tall og spesialtegn. ",
    validateEmail: "Du har ikke oppgitt en gyldig epostadresse. ",
    minLength3: "Feltet må inneholde minst 3 tegn. ",
    minLength5: "Feltet må inneholde minst 5 tegn. ",
    minLength8: "Feltet må inneholde minst 8 tegn. ",
    minLength11: "Feltet må inneholde 11 siffer. ",
    youHaveErrors: "Du har felter som ikke er utfylt eller har ugyldige verdier.  Du må korrigere dette før vi kan opprette ny kunde. ",
    prodTypeDefault: "Velg fra listen",
    prodtypePurre: "Purreservice – Vi sender inkassovarsel for deg",
    prodtypeInkasso: "Inkasso – Dere har sendt inkassovarsel til kunden",
    mvapliktDefault: "Velg fra listen",
    mvaplikt1: "Ja",
    mvaplikt0: "Nei",
    toastFinancialError: "Kunne ikke hente ut økonomisystemer (getFinancialSystems)",
    toastFinancialSystems: "Liste over økonomisystemer hentet.",
    toastFirmainfoNon200: "Ingen firmainformasjont funnet i Brønnøysundregistrene.",
    toastFirmainfoError: "Kunne ikke hente firmainformasjon fra Brønnøysundregistrene.",
    toastFirmaIntoHentet: "Firmainformasjon ble hentet fra Brønnøysundregistrene.",
    toastSaveError: "Kunne ikke opprette ny kreditor (newCreditor)",
    toastSaveOk: "Ny kreditor er lagret.",
    oksysDefault: "Velg fra listen",

    // from OnboardingPage1.i18n.js
    step1Title: "Steg 1: Velg ditt økonomisystem for å starte integreringen",
    step1Description1: "For å sette opp en smidig integrasjon mellom inkassosystemet og ditt økonomisystem, begynner vi med å velge hvilket system du bruker. Dette lar oss tilpasse veiledningen og sikre at prosessen er både effektiv og brukervennlig.",
    step1Description2: "Velg ditt økonomisystem fra listen nedenfor, og følg de enkle stegene som er spesifikke for din løsning. Dersom du trenger hjelp underveis, står vi klare til å bistå.",
    financialSystemLabel: "Økonomisystem",
    otherFinancialSystemLabel: "Navn på økonomisystem (valgfritt)",
    loadingText: "Laster...",
    
    // from OnboardingPage2.i18n.js
    step2Title: "Steg 2: Opprett en bruker",
    step2Description1: "For å komme i gang, må du opprette første bruker i systemet. Dette gir deg tilgang til alle funksjoner og sikrer en trygg og effektiv håndtering av inkassosaker. Flere brukere kan opprettes senere.",
    step2Description2: "Fyll inn nødvendig informasjon i registreringsskjemaet, og så er du klar til å bruke systemet!",
    userNameLabel: "Navn",
    userNameRequired: "Navn er påkrevd.",
    userNameMinLength: "Navn må være minst 2 tegn.",
    emailLabel: "E-post",
    emailRequired: "E-post er påkrevd.",
    emailInvalid: "Ugyldig e-postadresse. Bruk format: navn@domene.no",
    phoneLabel: "Telefonnummer",
    phoneRequired: "Telefonnummer er påkrevd.",
    phoneInvalid: "Ugyldig telefonnummer. Bruk 8 siffer (f.eks. 12345678) eller +47 12345678",
    passwordLabel: "Passord",
    passwordRequired: "Passord er påkrevd.",
    passwordMinLength: "Passord må være minst 8 tegn med bokstav, tall og spesialtegn.",
    passwordTooltip: "Minst 8 tegn med bokstav, tall og spesialtegn",
    confirmPasswordLabel: "Gjenta passord",
    confirmPasswordMismatch: "Passordene samsvarer ikke.",
    previousButton: "Forrige",
    nextButton: "Neste",
    loadingText: "Vennligst vent, oppretter bruker...",
    userCreatedSuccess: "Bruker opprettet!",
    serviceTypeHelp: "Om det ikke er sendt inkassovarsel, må valget «Inkassovarsel» velges.",
    validationErrorsDetected: "Skjemaet har valideringsfeil som må rettes.",
    formValidationErrors: "{count} {count, plural, one {felt} other {felter}} må rettes før du kan fortsette",
    passwordsMustMatch: "Passordene må være like",

    // from ExternalOnboardingInfo.i18n.js
    externalSystemMessage: "For å koble opp {systemDisplayName} mot Kreditorforeningen må du starte prosessen i {systemDisplayName}.",
    readMoreButton: "Les mer her",

    // from OnboardingSetupWrapper.js
    loadOnboardingError: "Kunne ikke laste onboarding data. Prøv å oppdatere siden.",
    saveSignatureError: "Kunne ikke lagre signatur status.",
    saveCompanyInfoError: "Kunne ikke lagre selskapsinfo.",
    saveAccountingSystemError: "Kunne ikke lagre regnskapssystem info.",
    createKosCreditorError: "Kunne ikke opprette kreditor. Prøv igjen senere.",
    setupIntegrationError: "Kunne ikke sette opp integrasjon. Prøv igjen senere.",
    completeOnboardingError: "Kunne ikke fullføre registreringen. Prøv igjen senere.",
    noTokenError: "Registrering fullført, men ingen token mottatt. Vennligst logg inn manuelt.",
    invalidAccess: "Ugyldig tilgang. Du må være logget inn med onboarding-rolle for å få tilgang til denne siden.",
    goToLogin: "Gå til innlogging",
    loadingOnboardingData: "Laster onboarding data...",
  }
};
